"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEPOSIT_ALTERNATIVE_3RD_PARTY_DEFAULTS = exports.DEPOSIT_ALTERNATIVE_DEFAULTS = exports.FIELD_SETTINGS_DEFAULTS = exports.ICON_URL = exports.OCCUPANCY_TYPE = void 0;
exports.OCCUPANCY_TYPE = 'occupancy-type';
exports.ICON_URL = 'icon-url';
// Field Settings Defaults
exports.FIELD_SETTINGS_DEFAULTS = {
    DATE_OF_BIRTH: {
        MIN_AGE: 18,
        UPPER_AGE_BOUNDARY: 200,
        LOWER_AGE_BOUNDARY: 15,
    },
};
// Deposit Alternative Defaults
exports.DEPOSIT_ALTERNATIVE_DEFAULTS = {
    TRADITIONAL_DEPOSIT_OPTION_TITLE: 'Traditional Security Deposit',
    TRADITIONAL_DEPOSIT_OPTION_DESCRIPTION: 'A portion or all of this deposit may be refundable at move out, refer to your lease language for more details.',
    DEPOSIT_ALTERNATIVE_OPTION_TITLE: 'Homebody Deposit',
    DEPOSIT_ALTERNATIVE_OPTION_DESCRIPTION: "The deposit option is a non-refundable monthly payment. An enrollment fee of {{amount}} will be due in addition to your first month's payment.",
};
exports.DEPOSIT_ALTERNATIVE_3RD_PARTY_DEFAULTS = {
    TRADITIONAL_DEPOSIT_OPTION_TITLE: 'Traditional Security Deposit',
    TRADITIONAL_DEPOSIT_OPTION_DESCRIPTION: 'A portion or all of this deposit may be refundable at move out, refer to your lease language for more details.',
    DEPOSIT_ALTERNATIVE_OPTION_TITLE: 'Third Party Deposit',
    DEPOSIT_ALTERNATIVE_OPTION_DESCRIPTION: 'The third party deposit option is a non-refundable monthly payment. Payment timing and amounts follow your lease or third-party provider terms.',
};
